// Copied from frontend-admin/src/components/common/CopyButton.jsx.
// Edit there first, then re-copy. A change made only here is drift.

import { useEffect, useRef, useState } from 'react'
import Button from './Button'

// The action keeps its name through the whole flow: the button says "Copy
// contact" and, having done it, says "Copied". It does not congratulate anyone.

export default function CopyButton({ text, label = 'Copy', size = 'sm', className = '' }) {
  const [copied, setCopied] = useState(false)
  const timer = useRef(null)

  useEffect(() => () => clearTimeout(timer.current), [])

  const copy = async () => {
    try {
      await navigator.clipboard.writeText(text)
      setCopied(true)
      clearTimeout(timer.current)
      timer.current = setTimeout(() => setCopied(false), 1600)
    } catch {
      // Clipboard access can be refused. Saying nothing is better than a toast
      // claiming success that did not happen.
      setCopied(false)
    }
  }

  return (
    <Button size={size} variant="ghost" onClick={copy} className={className}>
      {/* aria-live so the change is announced, not only seen. */}
      <span aria-live="polite">{copied ? 'Copied' : label}</span>
    </Button>
  )
}
